// i18n
import 'src/locales/i18n';

// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes';
// theme
import ThemeProvider from 'src/theme';
// locales
import { LocalizationProvider } from 'src/locales';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from './components/snackbar';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// sections
import { CheckoutProvider } from './sections/checkout/context';
// auth
// import { AuthProvider } from './auths/JwtContext';
// import { AuthConsumer } from './auths/auth-consumer';
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';

// import { AuthProvider, AuthConsumer } from 'src/auth/context/auth0';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/amplify';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/firebase';
import { store, persistor } from './redux/store';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
// import { AuthPublicConsumer, AuthPublicProvider } from './auth-public/context/jwt';
// ----------------------------------------------------------------------

export default function App() {
  localStorage.setItem('orgCode', '/app')
  // const [notification1, setNotification] = useState<string | null>(null);
  // useEffect(() => {
  //   const socket = io('http://localhost:8000'); // Replace with your server URL
  //   console.log(socket);
  //   socket.on('connect', () => {
  //     socket.emit('register', "e4c87eeb-1a06-41b6-84b7-658d1d02cbe6"); // Send the user ID to the server upon connection
  //   });
  //   socket.on('notification', (data: string) => {
  //     console.log(data,"notifications");
  //     setNotification(data);
  //   });

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  const charAt = `

  ░░░    ░░░
  ▒▒▒▒  ▒▒▒▒
  ▒▒ ▒▒▒▒ ▒▒
  ▓▓  ▓▓  ▓▓
  ██      ██🤘

  `;

  console.info(`%c${charAt}`, 'color: #5BE49B');

  useScrollToTop();

  return (
    <>
      <AuthProvider>
        <LocalizationProvider>
          <ReduxProvider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <SettingsProvider
                defaultSettings={{
                  themeMode: 'light', // 'light' | 'dark'
                  themeDirection: 'ltr', //  'rtl' | 'ltr'
                  themeContrast: 'default', // 'default' | 'bold'
                  themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
                  themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
                  themeStretch: false,
                }}
              >
                <ThemeProvider>
                  <MotionLazy>
                    <SnackbarProvider>
                      <CheckoutProvider>
                        <SettingsDrawer />
                        <ProgressBar />
                        <AuthConsumer>
                          <Router />
                        </AuthConsumer>
                      </CheckoutProvider>
                    </SnackbarProvider>
                  </MotionLazy>
                </ThemeProvider>
              </SettingsProvider>
            </PersistGate>
          </ReduxProvider>
        </LocalizationProvider>
      </AuthProvider>
    </>
  );
}
